import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Account, AccountMgmtState, AccountEditModalSource, PasswordResetModal } from './types';

const initialState: AccountMgmtState = {
    showGridSpinner: false,
    gridSource: {
        data: [],
        total: 0,
        view: [],
        filter: { searchTerm: null },
    },
    accountEditModal: {
        open: false,
        locked: false,
        source: null,
        serverError: '',
    },
    passwordResetModal: {
        header: "",
        open: false,
        locked: false,
        source: {
            currentUser: {
                email: '',
                isSuperAdmin: false,
                userId: '',
                userName: '',
                userRoles: [],
            },
            userId: null,
            password: null,
            confirmPassword: null,
        }
    }
};

const accountMgmtSlice = createSlice({
    name: 'accountMgmt',
    initialState,
    reducers: {
        setGridSource(state, action: PayloadAction<{ data: Account[], total: number }>) {
            state.gridSource.data = action.payload.data;
            state.gridSource.total = action.payload.total;
        },
        setGridView(state, action: PayloadAction<Account[]>) {
            state.gridSource.view = action.payload;
        },
        clearGridView(state) {
            state.gridSource.view = [];
        },
        changeSearchTerm(state, action: PayloadAction<string | null>) {
            state.gridSource.filter.searchTerm = action.payload;
        },
        toggleGridSpinner(state, action: PayloadAction<boolean>) {
            state.showGridSpinner = action.payload;
        },
        openAccountEditModal(state, action: PayloadAction<AccountEditModalSource>) {
            state.accountEditModal = {
                ...state.accountEditModal,
                open: true,
                source: action.payload,
            };
        },
        closeAccountEditModal(state) {
            state.accountEditModal = {
                open: false,
                locked: false,
                source: null,
                serverError: '',
            };
        },
        changeEditModalFields(state, action: PayloadAction<{ [key: string]: string | string[] | number | number[] | boolean}>) {
            state.accountEditModal.source = {
                ...state.accountEditModal.source,
                ...action.payload,
            } as AccountEditModalSource;
        },
        toggleModalSpinner(state, action: PayloadAction<boolean>) {
            state.accountEditModal.locked = action.payload;
        },
        setErrorEditModal(state, action: PayloadAction<string>) {
            state.accountEditModal.serverError = action.payload;
        },
        openPasswordResetModal(state, action: PayloadAction<{ header: string; source: PasswordResetModal['source'] }>) {
            state.passwordResetModal = {
                ...state.passwordResetModal,
                open: true,
                header: action.payload.header,
                source: action.payload.source
            }
        },
        togglePasswordModalSpinner(state, action: PayloadAction<boolean>) {
            state.passwordResetModal.locked = action.payload;
        },
        closePasswordResetModal(state) {
            state.passwordResetModal = initialState.passwordResetModal;
        },
        changePasswordModalFields(state, action: PayloadAction<{ [key: string]: string }>) {
            state.passwordResetModal.source = {
                ...state.passwordResetModal.source,
                ...action.payload,
            };
        }
    },
});


export const actions = accountMgmtSlice.actions;
export default accountMgmtSlice.reducer;